module.exports = __webpack_public_path__ + "img/Poly 3.jpg";